var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar" }, [
    _c(
      "div",
      { staticClass: "nav" },
      [
        _c(
          "v-app-bar",
          {
            attrs: {
              app: "",
              color: "white",
              "max-height": "70px",
              height: "70px"
            }
          },
          [
            _c("v-app-bar-nav-icon", {
              staticClass: "btn-drawer",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.drawer = !_vm.drawer
                }
              }
            }),
            _c("v-spacer"),
            _c(
              "v-list",
              { staticClass: "itens-nav" },
              [
                _vm.user.userProfile == 1 && _vm.appearInNavbar
                  ? _c("div", { staticClass: "pesquisar-usuario" }, [
                      _c("div", { staticClass: "ctrl-mock" }, [
                        _vm._v(_vm._s(_vm.selectedUserName))
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _c(
                      "v-btn",
                      {
                        ref: "btnBePro",
                        staticClass: "btn-be-pro",
                        attrs: { id: "SejaPro" },
                        on: {
                          click: function($event) {
                            return _vm.bePro($event)
                          }
                        }
                      },
                      [_vm._v(" SEJA PRO! ")]
                    ),
                    _c(
                      "v-dialog",
                      {
                        attrs: {
                          "content-class": "dialog-container",
                          "max-width": "90%"
                        },
                        model: {
                          value: _vm.dialogBePro,
                          callback: function($$v) {
                            _vm.dialogBePro = $$v
                          },
                          expression: "dialogBePro"
                        }
                      },
                      [
                        _c(
                          "v-card",
                          { staticClass: "card-dialog" },
                          [
                            _c(
                              "v-card-title",
                              { staticClass: "title-dialog" },
                              [
                                _c("span", { staticClass: "strong" }, [
                                  _vm._v(
                                    "Essa ação é apenas para usuários premium ou gold"
                                  )
                                ]),
                                _c("span", [
                                  _vm._v("Escolha o seu plano "),
                                  _c("span", { staticClass: "strong" }, [
                                    _vm._v("Kristal Connect")
                                  ])
                                ])
                              ]
                            ),
                            _c("div", { staticClass: "btns-capa" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "mensal",
                                  class: { clicado: _vm.anualOuMensal },
                                  on: { click: _vm.changeMensalOuAnual }
                                },
                                [_c("span", [_vm._v("Mensal")])]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "anual",
                                  class: { clicado: !_vm.anualOuMensal },
                                  on: { click: _vm.changeMensalOuAnual }
                                },
                                [_c("span", [_vm._v("Anual")])]
                              )
                            ]),
                            _c(
                              "v-card-actions",
                              { staticClass: "cards-dialog" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "card-d" },
                                  [
                                    _c("CardBasic", {
                                      attrs: {
                                        titleBtn: "Continuar com KristalBasic",
                                        showBtn: false
                                      }
                                    }),
                                    _c("div", { staticClass: "text" }, [
                                      _vm.user.planType == 0
                                        ? _c("span", [_vm._v("Seu plano !")])
                                        : _vm._e()
                                    ])
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "card-d" },
                                  [
                                    _c("CardPremium", {
                                      attrs: {
                                        titleBtn: "Escolher KristalPadrão",
                                        showBtn: false
                                      }
                                    }),
                                    _c("div", { staticClass: "text" }, [
                                      _vm.user.planType == 1
                                        ? _c("span", [_vm._v("Seu plano !")])
                                        : _vm._e()
                                    ])
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "card-d" },
                                  [
                                    _c("CardGold", {
                                      attrs: {
                                        titleBtn: "Escolher KristalSênior",
                                        showBtn: false
                                      }
                                    }),
                                    _c("div", { staticClass: "text" }, [
                                      _vm.user.planType == 2
                                        ? _c("span", [_vm._v("Seu plano !")])
                                        : _vm._e()
                                    ])
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "btn-close-dialog",
                                on: { click: _vm.closeDialog }
                              },
                              [
                                _c("v-img", {
                                  attrs: {
                                    src: require("@/assets/icons/clear_icon.svg")
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "btn-plano-diferente",
                                on: { click: _vm.goChoosePlan }
                              },
                              [
                                _c("span", [
                                  _vm._v(" Escolher um plano diferente ")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _vm.appearInNavbar
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "", color: "blue" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "tooltip",
                                              attrs: {
                                                id: "CadastrarCompra",
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showModal(
                                                    "CadastrarCompra",
                                                    $event
                                                  )
                                                }
                                              }
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c("img", {
                                            staticClass: "icon",
                                            attrs: {
                                              src: require("@/assets/icons/up-and-down-arrow.svg"),
                                              alt: "dashboard"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3537086903
                            )
                          },
                          [_c("span", [_vm._v("Movimentar Ativo")])]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _vm.appearInNavbar
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "", color: "blue" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "tooltip",
                                              attrs: {
                                                id: "CadastrarVenda",
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showModal(
                                                    "CadastrarVenda",
                                                    $event
                                                  )
                                                }
                                              }
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c("img", {
                                            staticClass: "icon",
                                            attrs: {
                                              src: require("@/assets/icons/close.svg"),
                                              alt: "dashboard"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3834056905
                            )
                          },
                          [_c("span", [_vm._v("Excluir Ativo")])]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _vm.appearInNavbar
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "", color: "blue" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "tooltip",
                                              attrs: {
                                                id: "EditarEstrategia",
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showModal(
                                                    "EditarEstrategia",
                                                    $event
                                                  )
                                                }
                                              }
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c("img", {
                                            staticClass: "icon",
                                            attrs: {
                                              src: require("@/assets/icons/edit_icon.svg"),
                                              alt: "Strategy"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1211787336
                            )
                          },
                          [_c("span", [_vm._v("Editar estratégia")])]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm.user.userProfile == 1
                  ? _c(
                      "v-list-item",
                      { staticClass: "item-nav" },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "", color: "blue" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "router-link",
                                        { attrs: { to: "/gestao-usuario" } },
                                        [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "tooltip",
                                                  attrs: { icon: "" }
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("img", {
                                                staticClass: "icon",
                                                attrs: {
                                                  src: require("@/assets/icons/gestao_usuario_icon.svg"),
                                                  alt: "perfil"
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2523973657
                            )
                          },
                          [_c("span", [_vm._v("Gestão de usuários")])]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", color: "blue" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/perfil" } },
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "tooltip",
                                            attrs: { icon: "" }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("img", {
                                          staticClass: "icon",
                                          attrs: {
                                            src: require("@/assets/icons/profile_icon.svg"),
                                            alt: "perfil"
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [_c("span", [_vm._v("Perfil")])]
                    )
                  ],
                  1
                ),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", color: "blue" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/importacao" } },
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "tooltip",
                                            attrs: {
                                              id: "ImportarAtivo",
                                              icon: ""
                                            }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("img", {
                                          staticClass: "icon",
                                          attrs: {
                                            src: require("@/assets/icons/import.svg"),
                                            alt: "dashboard"
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [_c("span", [_vm._v("Importar Ativo(s).")])]
                    )
                  ],
                  1
                ),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", color: "blue" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/visao-geral" } },
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "tooltip",
                                            attrs: { icon: "" }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("img", {
                                          staticClass: "icon",
                                          attrs: {
                                            src: require("@/assets/icons/dashboard_icon.svg"),
                                            alt: "dashboard"
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [_c("span", [_vm._v("Visão Geral")])]
                    )
                  ],
                  1
                ),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", color: "blue" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/rentabilidade" } },
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "tooltip",
                                            attrs: { icon: "" }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("img", {
                                          staticClass: "icon",
                                          attrs: {
                                            src: require("@/assets/icons/pizza_icon.svg"),
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [_c("span", [_vm._v("Rentabilidade")])]
                    )
                  ],
                  1
                ),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", color: "blue" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/liquidez" } },
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "tooltip",
                                            attrs: { icon: "" }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("img", {
                                          staticClass: "icon",
                                          attrs: {
                                            src: require("@/assets/icons/money_icon.svg"),
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [_c("span", [_vm._v("Liquidez")])]
                    )
                  ],
                  1
                ),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", color: "blue" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/carteira" } },
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "tooltip",
                                            attrs: { icon: "" }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("img", {
                                          staticClass: "icon",
                                          attrs: {
                                            src: require("@/assets/icons/wallet_icon.svg"),
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [_c("span", [_vm._v("Carteira")])]
                    )
                  ],
                  1
                ),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", color: "blue" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/report-tables" } },
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "tooltip",
                                            attrs: { icon: "" }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("img", {
                                          staticClass: "icon",
                                          attrs: {
                                            src: require("@/assets/icons/relatorio.svg"),
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [_c("span", [_vm._v("Relatório")])]
                    )
                  ],
                  1
                ),
                _c(
                  "v-list-item",
                  { staticClass: "item-nav" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", color: "blue" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/ReportMonth" } },
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "tooltip",
                                            attrs: { icon: "" }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("img", {
                                          staticClass: "icon",
                                          attrs: {
                                            src: require("@/assets/icons/informacoes.svg"),
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [_c("span", [_vm._v("Informações")])]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "close-on-content-click": false,
                          "nudge-width": 200,
                          "offset-y": "",
                          rounded: "lg",
                          "max-width": "300"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-card-actions",
                                  [
                                    _c(
                                      "v-list-item",
                                      { staticClass: "grow" },
                                      [
                                        _c(
                                          "v-list-item-avatar",
                                          [
                                            _c(
                                              "v-img",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "elevation-6 img-profila-web",
                                                    attrs: {
                                                      alt: "",
                                                      src: _vm.imagemPerfil
                                                    }
                                                  },
                                                  "v-img",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              )
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.menu,
                          callback: function($$v) {
                            _vm.menu = $$v
                          },
                          expression: "menu"
                        }
                      },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "card-profile mx-auto",
                            attrs: { "max-width": "300" }
                          },
                          [
                            _c(
                              "v-list",
                              [
                                _c(
                                  "v-list-item",
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "text-lg name" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.userFormated.name ||
                                                    "Nome não registrado"
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "email" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.userFormated.email)
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("v-divider", {
                              staticStyle: {
                                "border-color": "#f6f6f6 !important"
                              }
                            }),
                            _c(
                              "v-list",
                              [
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass:
                                      "item d-flex justify-center align-center p-5",
                                    on: { click: _vm.goToConfig }
                                  },
                                  [
                                    _c("v-img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("@/assets/icons/config_icon.svg")
                                      }
                                    }),
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "title" },
                                      [_c("span", [_vm._v("Configurações")])]
                                    )
                                  ],
                                  1
                                ),
                                _c("v-divider", {
                                  staticStyle: {
                                    "border-color": "#f6f6f6 !important"
                                  }
                                }),
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass:
                                      "item d-flex justify-center align-center p-5",
                                    on: { click: _vm.logout }
                                  },
                                  [
                                    _c("v-img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("@/assets/icons/sair_icon.svg")
                                      }
                                    }),
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "title" },
                                      [_c("span", [_vm._v("Sair")])]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-navigation-drawer",
          {
            staticClass: "navigation-drawer-wrapper",
            attrs: { fixed: "", temporary: "" },
            model: {
              value: _vm.drawer,
              callback: function($$v) {
                _vm.drawer = $$v
              },
              expression: "drawer"
            }
          },
          [
            _c(
              "v-list",
              { attrs: { nav: "", dense: "" } },
              [
                _c(
                  "v-list-item-group",
                  {
                    attrs: {
                      "active-class": "deep-purple--text text--accent-4"
                    },
                    model: {
                      value: _vm.group,
                      callback: function($$v) {
                        _vm.group = $$v
                      },
                      expression: "group"
                    }
                  },
                  [
                    _vm.user.userProfile == 1 && _vm.appearInNavbar
                      ? _c("div", { staticClass: "drawer-mobile" }, [
                          _c("div", { staticClass: "ctrl-mock" }, [
                            _vm._v(_vm._s(_vm.selectedUserName))
                          ])
                        ])
                      : _vm._e(),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-list-item-title",
                          [
                            _vm.appearInNavbar
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "tooltip",
                                    attrs: { id: "CadastrarCompra", icon: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.showModal(
                                          "CadastrarCompra",
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "icon",
                                      attrs: {
                                        src: require("@/assets/icons/up-and-down-arrow.svg"),
                                        alt: "dashboard"
                                      }
                                    }),
                                    _c("span", { staticClass: "name-action" }, [
                                      _vm._v("Movimentar Ativo")
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-list-item-title",
                          [
                            _vm.appearInNavbar
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "tooltip",
                                    attrs: { id: "CadastrarVenda", icon: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.showModal(
                                          "CadastrarVenda",
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "icon",
                                      attrs: {
                                        src: require("@/assets/icons/close.svg"),
                                        alt: "dashboard"
                                      }
                                    }),
                                    _c("span", { staticClass: "name-action" }, [
                                      _vm._v("Excluir ativo")
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      { staticClass: "item-nav" },
                      [
                        _c(
                          "v-list-item-title",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "tooltip",
                                attrs: { id: "CadastrarVenda", icon: "" },
                                on: { click: _vm.goToGestaoUsuario }
                              },
                              [
                                _c("img", {
                                  staticClass: "icon",
                                  attrs: {
                                    src: require("@/assets/icons/gestao_usuario_icon.svg"),
                                    alt: "perfil"
                                  }
                                }),
                                _c("span", { staticClass: "name-action" }, [
                                  _vm._v("Gestão de usuários")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-list-item-title",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "tooltip",
                                attrs: { icon: "" },
                                on: { click: _vm.goToVisaoGeral }
                              },
                              [
                                _c("img", {
                                  staticClass: "icon",
                                  attrs: {
                                    src: require("@/assets/icons/dashboard_icon.svg"),
                                    alt: "dashboard"
                                  }
                                }),
                                _c("span", { staticClass: "name-action" }, [
                                  _vm._v("Visão Geral")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-list-item-title",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "tooltip",
                                attrs: { icon: "" },
                                on: { click: _vm.goToRentabilidade }
                              },
                              [
                                _c("img", {
                                  staticClass: "icon",
                                  attrs: {
                                    src: require("@/assets/icons/pizza_icon.svg"),
                                    alt: ""
                                  }
                                }),
                                _c("span", { staticClass: "name-action" }, [
                                  _vm._v("Rentabilidade")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "tooltip",
                            attrs: { icon: "" },
                            on: { click: _vm.goToLiquidez }
                          },
                          [
                            _c("img", {
                              staticClass: "icon",
                              attrs: {
                                src: require("@/assets/icons/money_icon.svg"),
                                alt: ""
                              }
                            }),
                            _c("span", { staticClass: "name-action" }, [
                              _vm._v("Liquidez")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "tooltip",
                            attrs: { icon: "" },
                            on: { click: _vm.goToCarteira }
                          },
                          [
                            _c("img", {
                              staticClass: "icon",
                              attrs: {
                                src: require("@/assets/icons/wallet_icon.svg"),
                                alt: ""
                              }
                            }),
                            _c("span", { staticClass: "name-action" }, [
                              _vm._v("Carteira")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "tooltip",
                            attrs: { icon: "" },
                            on: { click: _vm.goToReport }
                          },
                          [
                            _c("img", {
                              staticClass: "icon",
                              attrs: {
                                src: require("@/assets/icons/upload.svg"),
                                alt: ""
                              }
                            }),
                            _c("span", { staticClass: "name-action" }, [
                              _vm._v("Relatório")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c("v-list-item", { staticClass: "profile" }, [
                      _c("div", { staticClass: "card-profile-mobile" }, [
                        _c(
                          "div",
                          { staticClass: "card-profile-mobile-header" },
                          [
                            _c(
                              "v-list-item-avatar",
                              [
                                _c("v-img", {
                                  staticClass: "elevation-6",
                                  attrs: { alt: "", src: _vm.imagemPerfil }
                                })
                              ],
                              1
                            ),
                            _c("v-list-item-title", [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.user.name || "Alexandre Mendes")
                                )
                              ])
                            ])
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "card-profile-mobile-configs" },
                          [
                            _c(
                              "v-list",
                              [
                                _c("v-divider", {
                                  staticStyle: {
                                    "border-color": "#f6f6f6 !important"
                                  }
                                }),
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass: "item",
                                    on: { click: _vm.goToConfig }
                                  },
                                  [
                                    _c("v-img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("@/assets/icons/config_icon.svg")
                                      }
                                    }),
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "title" },
                                      [_c("span", [_vm._v("Configurações")])]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass: "item logout-action",
                                    on: { click: _vm.logout }
                                  },
                                  [
                                    _c("v-img", {
                                      staticClass: "img",
                                      attrs: {
                                        src: require("@/assets/icons/sair_icon.svg")
                                      }
                                    }),
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "title" },
                                      [_c("span", [_vm._v("Sair")])]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }